import MyScoreBox from './score-box.vue';
import MyEditScoreBox from './socre-box-edit.vue';

const ScoreBox = {
  install: (Vue: any) => {
    Vue.component('ScoreBox', MyScoreBox);
    Vue.component('EditScoreBox', MyEditScoreBox);
  },
};

export default ScoreBox;
